const GqfLayoutRoutes = [
  {
    path: "/gqf",
    name: "gqf",
    component: () => import("@/components/layout/GqfLayout.vue"),
    redirect: "/gqf/overview",
    meta: {
      title: "GQF 소개",
      isDynamic: false,
    },
    children: [
      /** 평생학습플랫폼 목록 */
      {
        label: "GQF 소개",
        path: "overview",
        component: () => import("@/views/student/overview/GqfOverview.vue"),
      },
      {
        label: "비전 및 목표",
        path: "vision",
        component: () => import("@/views/student/overview/GqfVision.vue"),
      },
      {
        label: "찾아오시는 길",
        path: "map",
        component: () => import("@/views/student/overview/GqfMap.vue"),
      },
      {
        label: "관련 사이트",
        path: "links",
        component: () => import("@/views/student/overview/GqfLinks.vue"),
      },
    ],
  },
];

export default GqfLayoutRoutes;
